<template>
  <div class="pfx-admin-menu">
    <h1 class="above-menu">PFX Platform Administration</h1>
    <nav>
      <ul>
        <router-link tag="li" to="/pfxadmin/tenants">Broker Accounts (Tenants)</router-link>
        <router-link tag="li" to="/pfxadmin/applications">Applications</router-link>
        <router-link tag="li" to="/pfxadmin/users">PFX Admins</router-link>
        <!--<router-link tag="li" to="/pfxadmin/content">Content</router-link>-->
      </ul>
    </nav>
  </div>
</template>

<script>
  export default {
    name: 'PfxAdminMenu'
  }
</script>

<style lang="scss" scoped>
  @import '../pfx.scss';

  .pfx-admin-menu {
    nav {
      margin-bottom: 1rem;
      border-bottom: 1px solid #eee;

      li { // TODO centralized css for menus (company profile, pfxadmin)
        @include tablet-portrait-breakpoint {
          display: inline-block;
          min-width: 200px;
          text-align: center;
        }

        padding: 0.5rem 0;
        cursor: pointer;
        color: #b3b3b3;
      }
      li.router-link-active {
        color: #000;
        border-bottom: 2px solid $color-pfx-brand;
        font-weight: 600;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/PfxAdminMenu.vue